<template>
	<div>
		<div class="dev-settings" :class="{collapsed: !visible}">
			<el-form class="site-options" ref="siteOptions" :model="siteOptions" label-width="80px" label-position="top">
				<el-form-item label="改变布局">
					<el-radio-group v-model="siteOptions.layout" @change="changeLayout" class="my-radio-group">
						<el-radio label="HeaderLeftMainLayout">
							<div class="layout-icon-wrapper">
								<div class="layout-icon-header" style="left: 14px;"></div>
								<div class="layout-icon-side-left menu-part"></div>
							</div>
							<div class="my-radio-label">左侧菜单</div>
						</el-radio>
						<el-radio label="HeaderMainLayout" >
							<div class="layout-icon-wrapper">
								<div class="layout-icon-header menu-part"></div>
							</div>
							<div class="my-radio-label">顶部菜单</div>
						</el-radio>
						<el-radio label="HeaderLeftMenusMainLayout" >
							<div class="layout-icon-wrapper">
								<div class="layout-icon-header menu-part"></div>
								<div class="layout-icon-side-left menu-part" style="top: 14px;"></div>
							</div>
							<div class="my-radio-label">顶部+左侧菜单</div>
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="切换皮肤">
					<el-radio-group v-model="siteOptions.theme" @change="changeTheme" class="my-radio-group">
						<el-radio label="default">
							<div class="theme-icon" style="background-color: #002140;"></div>
							<div class="my-radio-label">默认(深色)</div>
						</el-radio>
						<el-radio label="green">
							<div class="theme-icon" style="background-color: #48c570;"></div>
							<div class="my-radio-label">绿色</div>
						</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="多页签模式">
					<el-radio-group v-model="siteOptions.isTabbedMenu" @change="changeTabbed">
						<el-radio
							v-for="item in menuTypes"
							:label="item.id"
							:key="item.id"
						>{{item.name}}</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div class="toggle-btn" @click="visible = !visible">
				<i v-if="visible" class="el-icon-close"></i>
				<i v-else class="el-icon-setting"></i>
			</div>
		</div>
		<div v-if="visible" class="page-mask" style="z-index: 999999998" @click="visible = false"></div>
	</div>
</template>


<script>
  import siteOptions from '@/config/index'
  import { isTabbedMenu } from '@/config/menu';

  let layoutsConfig = {
    "layouts": [
      {
        "id": "HeaderLeftMainLayout",
        "name": "左侧菜单"
      }, {
        "id": "HeaderMainLayout",
        "name": "顶部菜单"
      }, {
        "id": "HeaderLeftMenusMainLayout",
        "name": "顶部+左侧菜单"
      }
    ],
  	"default": "HeaderLeftMainLayout"
  }

	export default {
		data(){
      return {
				visible: false,
        siteOptions: {
					theme: localStorage.getItem('fav-theme') || siteOptions['theme'] || 'default',
          layout: localStorage.getItem('fav-layout') || layoutsConfig['default'],
          isTabbedMenu: localStorage.getItem('fav-is-tabbed-menu') || (isTabbedMenu ? '1' : '0')
        }
      }
    },
    computed: {
      allLayouts(){
        return layoutsConfig['layouts']
      },
			allThemes(){
				return [
		      {
		        "id": "default",
		        "name": "默认(深色)"
		      }, {
		        "id": "green",
		        "name": "绿色"
		      }
				]
			},
      menuTypes(){
        return [
          {id: '0', name: '禁用'},
          {id: '1', name: '启用'}
        ]
      }
    },
    methods: {
      changeLayout(){
        localStorage.setItem('fav-layout', this.siteOptions.layout)
        this.reloadPage()
      },
      changeTabbed(){
        localStorage.setItem('fav-is-tabbed-menu', this.siteOptions.isTabbedMenu)
        this.reloadPage()
      },
			changeTheme(){
				localStorage.setItem('fav-theme', this.siteOptions.theme)
        this.reloadPage()
			},
      reloadPage(){
        this.$nextTick(()=>{
          window.location.reload()
        }, 500)
      }
    }
	}
</script>


<style lang="scss" scoped>
	$devToolWidth: 320px;
	$toggleBtnSize: 40px;
	.dev-settings{
		position: fixed;
		background-color: #FFF;
		width: $devToolWidth;
		top: 0;
		right: 0;
		bottom: 0;
		z-index: 999999999;
		transition: right 0.3s;
    box-shadow: -2px 0 8px rgba(0,0,0,.15);
		padding: 10px 10px 10px 20px;
		&.collapsed {
			right:  -$devToolWidth;
			box-shadow: none;
		}
		.toggle-btn{
	    position: absolute;
	    background: #48c570;
	    top: 48%;
	    left: -$toggleBtnSize;
	    width: $toggleBtnSize;
	    height: $toggleBtnSize;
	    color: #FFF;
	    text-align: center;
	    line-height: $toggleBtnSize;
	    font-size: 26px;
			border-radius: 5px 0 0 5px;
			cursor: pointer;
		}
	}
	.layout-icon-wrapper{
		background-color: #FFF;
		border: solid 1px #CCC;
		position: relative;
		width: 60px;
		height: 60px;
		border-radius: 3px;
		overflow: hidden;
		.layout-icon-header, .layout-icon-side-left{
			position: absolute;
			left: 0;
			top: 0;
			right: 0;
			bottom: 0;
		}
		.layout-icon-header{
			bottom: auto;
			height: 14px;
			border-bottom: dashed 1px #CCC;
		}
		.layout-icon-side-left{
			right: auto;
			width: 14px;
			border-right: dashed 1px #CCC;
		}
		.menu-part {
			background-color: #EEE;
		}
	}
	.theme-icon{
		background-color: #FFF;
		position: relative;
		width: 40px;
		height: 40px;
		border-radius: 3px;
		overflow: hidden;
	}
	.my-radio-group ::v-deep {
		.el-radio{
			margin-left: 0!important;
			margin-right: 15px!important;
			position: relative;
		}
		.el-radio__input{
	    position: absolute;
	    left: 0;
	    bottom: 8px;
		}
		.el-radio__label{
			display: block;
			padding-left: 0!important;
		}
		.my-radio-label{
			text-indent: 16px;
			line-height: 2.5em;
		}
	}

	.site-options {
    ::v-deep .el-form-item {
      margin-bottom: 35px;
			.el-form-item__label{
				padding-bottom: 0;
				line-height: 3.8em;
				//color: #000;
				&:before{
					content: '\00BB '
				}
			}
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>
